import React from "react";
import Header from "../../../../components/Header/Header";
import LeftSideBar from "../../../../components/LeftSideBar/LeftSideBar";
import { Grid, Box } from "@mui/material";
import AuditTable from "../../../../components/AuditTable";
import AdministratorHeader from "../../../../components/Header/AdministratorHeader";

export default function index() {
  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader text="Audit Trail" />
            <Grid item md={12}>
              <AuditTable />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
